export default "__VITE_ASSET__D_rvP6OD__"